export const LOAD = 'V-PLAYER-HUYA-AD_EVENT-LOAD'
export const CLICK = 'V-PLAYER-HUYA-AD_EVENT-CLICK'
export const COMPLETE = 'V-PLAYER-HUYA-AD_EVENT-COMPLETE'
export const ERROR = 'V-PLAYER-HUYA-AD_EVENT-ERROR'
export const NO_AD = 'V-PLAYER-HUYA-AD_EVENT-NO_AD'
export default {
  LOAD,
  CLICK,
  COMPLETE,
  ERROR,
  NO_AD,
}
